<template>
  <div class="fixed top-0 grid w-full h-full overflow-hidden pointer-events-none z-10 pt-safe">
    <transition-group
      class="h-full flex flex-col gap-2 w-[20rem] mt-4 overflow-y-auto self-start justify-self-end items-center"
      tag="div"
      name="list"
      appear
      @before-leave="beforeLeave"
    >
      <l-notification
        v-for="notification in notifications"
        :key="notification.id"
        class="pointer-events-auto"
        v-bind="notification"
        @close="() => close(notification.id)"
        @cancel="() => close(notification.id)"
      />
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'

import LNotification from '../../components/Notifications/LNotification.vue'
import { useNotification } from './notification'

const { notifications, close } = useNotification()

watch(
  () => notifications,
  newNotifications => {
    newNotifications.forEach(notification => {
      if (notification.progress || notification.progress === 0) {
        const progress = Number(notification.progress)
        if (progress >= 100) {
          setTimeout(() => {
            close(notification.id)
          }, 500)
        }
        return
      }

      if (notification.duration === Infinity) return

      setTimeout(() => {
        close(notification.id)
      }, notification.duration ?? 3000)
    })
  },
  { deep: true }
)

const beforeLeave = (element: Element) => {
  const el = element as HTMLElement
  const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)

  el.style.left = `${el.offsetLeft - parseFloat(marginLeft)}px`
  el.style.top = `${el.offsetTop - parseFloat(marginTop)}px`
  el.style.width = width
  el.style.height = height
}
</script>

<style scoped>
.list-enter-from {
  opacity: 0;
  transform: scale(0.6);
}

.list-enter-active {
  transition: all 0.4s ease;
}

.list-leave-to {
  opacity: 0;
  transform: scale(0.6);
}

.list-leave-active {
  transition: all 0.3s ease;
  position: absolute;
}

.list-move {
  transition: all 0.3s ease;
}
</style>
